import React, { Component } from 'react';
import Datas from '../../data/blog/grid.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import Pagination from './../../components/Pagination';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/blog.js';

class BlogGrid extends Component {
    render() {
        return (
            <Styles>
                <div className="main-wrapper blog-grid-page">
                    <HeaderTwo />

                    <BreadcrumbBox title="Blog Grid" />

                    <section className="blog-grid-area">
                        <Container>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <Row>
                                        {Datas.map((data, i) => (
                                            <Col lg="4" md="6" sm="12" key={i}>
                                                <div className="blog-item">
                                                    <div className="blog-img">
                                                        <Link to={`/blog-details/${data.id}`}>
                                                            <img
                                                                src={`/assets/images/${data.postImg}`}
                                                                alt={data.postTitle}
                                                                className="img-fluid"
                                                            />
                                                        </Link>
                                                    </div>

                                                    <div className="blog-content">
                                                        <div className="blog-auth_date d-flex">
                                                            <div className="author-img d-flex">
                                                                <Link to={data.authorLink}>
                                                                    <img
                                                                        src={`/assets/images/${data.authorImg}`}
                                                                        alt={data.authorName}
                                                                    />
                                                                </Link>
                                                                <p>
                                                                    <Link to={data.authorLink}>{data.authorName}</Link>
                                                                </p>
                                                            </div>

                                                            <div className="post-date">
                                                                <p>
                                                                    <i className="las la-calendar"></i> {data.postDate}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="blog-title">
                                                            <h6>
                                                                <Link to={`/blog-details/${data.id}`}>
                                                                    {data.postTitle}
                                                                </Link>
                                                            </h6>
                                                        </div>

                                                        <div className="blog-desc">
                                                            <p>{data.postDesc}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>

                                    <div className="text-center">
                                        <Pagination />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    <FooterTwo />
                </div>
            </Styles>
        );
    }
}

export default BlogGrid;